<template>
  <a-modal
    :title="modalTitle"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="visible=false"
    :footer="null"
  >
    <div style="margin-bottom:20px">{{content}}</div>
    <div style="margin-top:5px" v-for="(item,index) in imgUrls" :key="index">
      <img alt="图片" width="100%" :src="item" @error="errorLoadImg" />
    </div>
  </a-modal>
</template>
<script>
import feedback from "../../api/feedback";

export default {
  name: "feedbackForm",
  data() {
    return {
      modalTitle: "",
      id: -1,
      visible: false,
      confirmLoading: false,
      content: "",
      imgUrls: []
    };
  },
  methods: {
    //初始化，显示
    init(params) {
      this.id = params.id;
      this.visible = true;
      this.modalTitle = "意见反馈";
      this.value = "";
      this.content= "";
      this.imgUrls= [];
      this.getDetail(params.id);
    },
    //获取详情
    getDetail(id) {
      feedback.detail({ id }).then(res => {
        console.log(res);
        this.content = res.data.content;
        this.imgUrls = res.data.imgUrls;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 50px 20px 30px;
  background: white;
  margin: 20px auto;
}
.ap-form {
  width: 400px;
}
.form-oper {
  text-align: center;
  button {
    margin: 0px 5px;
  }
}
</style>